import { useCallback, useEffect, useState } from 'react';
import { useKeyPress } from '../../Shared/UseKeyPress';
import { AnnotationsForGrid, PathContextType } from '../../AnnotationManager/Annotation/annotation.types';
import { ValidationModalDto } from '../Annotation/AnnotationValidationModal/AnnotationValidationModal.slice';
import { Direction, DirectionOptions, getNextAnnotation } from '../Annotation/Images/helpers';

export default function UseAnnotationsHelpers(
  gridData: any,
  pathContext: PathContextType,
  saveFinding: boolean,
  showCreateAnnotationModal: boolean,
  validationModalData: ValidationModalDto,
  presentAnnotations: AnnotationsForGrid[] | null,
  selectedAnnotationId: string,
  onSaveFinding: (saveFinding: boolean) => void,
  onFindingNavigation: (sequencePath: string, imageName: string, id: string) => void,
  onFindingChangedOnArrow: (value: boolean) => void
) {
  const [pressedDown, setPressedDown] = useState(false);
  const [pressedUp, setPressedUp] = useState(false);
  const [processKeyEvent, setProcessKeyEvent] = useState(false);

  const processPressEvent = useCallback(
    (gridData: any, upDown: Direction) => {
      if (pathContext === 'with-images') {
        return;
      }

      if (!(gridData && gridData.length && !(showCreateAnnotationModal && !validationModalData.showModal))) {
        return;
      }

      if (presentAnnotations && presentAnnotations.some(x => x.dirty)) {
        setProcessKeyEvent(true);
        onSaveFinding(true);

        if (upDown === 1) {
          setPressedDown(true);
        } else {
          setPressedUp(true);
        }

        return;
      }

      const nextAnnotation = getNextAnnotation(gridData, selectedAnnotationId, upDown);

      if (!nextAnnotation) {
        return;
      }

      onFindingNavigation(nextAnnotation.sequencePath, nextAnnotation.imageName, nextAnnotation.id);
      onFindingChangedOnArrow(true);
    },
    [
      onFindingNavigation,
      onSaveFinding,
      onFindingChangedOnArrow,
      pathContext,
      presentAnnotations,
      selectedAnnotationId,
      showCreateAnnotationModal,
      validationModalData.showModal
    ]
  );

  useEffect(() => {
    if (!saveFinding) {
      setProcessKeyEvent(false);
    }
  }, [saveFinding]);

  useEffect(() => {
    if ((pressedDown || pressedUp) && !processKeyEvent) {
      if (pressedUp) {
        processPressEvent(gridData, DirectionOptions.UP);
        setPressedUp(false);
      }

      if (pressedDown) {
        processPressEvent(gridData, DirectionOptions.DOWN);
        setPressedDown(false);
      }
    }
  }, [gridData, pressedDown, pressedUp, processKeyEvent, processPressEvent]);

  useKeyPress('ArrowDown', false, () => {
    processPressEvent(gridData, DirectionOptions.DOWN);
  });
  useKeyPress('ArrowUp', false, () => {
    processPressEvent(gridData, DirectionOptions.UP);
  });
}
